import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { FileTypeEnum, IFile } from '@repo/toolkit/types'
import { CheckMarkIcon, MinusIcon } from '@repo/ui/icons'
import React from 'react'

import useAuth from '../../../lib/hooks/use-auth'
import { TravelExpenseInput } from '../../../lib/types/models/travel-expenses/travel-expenses'
import {
  InvoiceButton,
  UploadInvoicesButton,
  userInvoiceColorMapping,
  userUploadInvoiceColorMapping
} from '../centers/center-costs/center.ui'

type TravelExpensesValidateButtonProps = {
  input: TravelExpenseInput
  validate: (id: number) => void
  invalidate: (id: number) => void
  remove: (id: number) => void
}

export const TravelExpensesValidateButton: React.FC<TravelExpensesValidateButtonProps> = ({
  input,
  validate,
  invalidate,
  remove
}) => {
  const { id, createdByUserRole, validated } = input
  const { user } = useAuth()
  return validated ? (
    <div
      className="flex justify-center items-center rounded-full cursor-pointer w-9 h-9 bg-green-light-active"
      onClick={() => invalidate(id)}
    >
      <div className="flex justify-center items-center rounded-full w-6 h-6 bg-green">
        <CheckMarkIcon color={tailwindColors.white.DEFAULT} width="16px" height="16px" />
      </div>
    </div>
  ) : (
    <div className="flex items-center gap-1">
      <div
        className="flex justify-center items-center border border-grey-light bg-white rounded cursor-pointer w-9 h-9"
        onClick={() => validate(id)}
      >
        <CheckMarkIcon color={tailwindColors.green.DEFAULT} width="18px" height="18px" />
      </div>
      {createdByUserRole === user.role && (
        <div
          className="flex justify-center items-center border border-grey-light bg-white rounded cursor-pointer w-9 h-9"
          onClick={() => remove(id)}
        >
          <MinusIcon color={tailwindColors.grey.DEFAULT} width="18px" height="18px" />
        </div>
      )}
    </div>
  )
}

type TravelExpensesInvoiceButtonProps = {
  input: TravelExpenseInput
  editable: boolean

  deleteDocument: (id: number) => void
  addDocument: (document: IFile, id: number) => void
}

export const TravelExpensesInvoiceButton: React.FC<TravelExpensesInvoiceButtonProps> = ({
  input,
  editable,
  addDocument,
  deleteDocument
}) => {
  const { user } = useAuth()
  return input.document ? (
    <InvoiceButton
      variant={userInvoiceColorMapping[user.role]}
      invoice={input.document}
      readOnly={!editable}
      onDelete={() => deleteDocument(input.id)}
    />
  ) : editable ? (
    <UploadInvoicesButton
      variant={userUploadInvoiceColorMapping[user.role]}
      types={[FileTypeEnum.PDF, FileTypeEnum.IMAGE]}
      onChange={(files) => {
        if (files.length > 0) addDocument(files[0], input.id)
      }}
    />
  ) : (
    '-'
  )
}
